import {TdoTableRowModel} from './tdo-table-row.model';

export class TdoTableSelectionEvent {
  isSelected: boolean;
  row: TdoTableRowModel;
  model: any;
  isMultiSelection = false;
  allSelectedRows: any[];
  mouseEvent: MouseEvent;
}
